import OliverText from "@builder/components/general/OliverText";
import "./style.scss";
import UnitInput from "@builder/components/general/UnitInput";
import { useTranslation } from "react-i18next";
import IncrementInput from "@builder/components/general/IncrementInput";
import useDebouncedCallback from "@builder/hooks/useDebounceCallback";

interface SliderInputProps {
    title?: string;
    value?: string;
    unit: string;
    min: number;
    max: number;
    unitMin?: number;
    unitMax?: number;
    incrementMode?: boolean;
    callback: (value: string, unit: string) => void;
}

const SliderInput = ({ title, value, unit, min, max, unitMin, unitMax, incrementMode, callback }: SliderInputProps) => {
    const { t } = useTranslation();

    const rangeValue = value ? (parseInt(value) > max ? max : parseInt(value) < min ? min : parseInt(value)) : min;
    const percent = ((rangeValue - min) / (max - min)) * 100;
    const debouncedCallback = useDebouncedCallback(callback, 5);

    const unitInputCallback = (value: string, unit: string) => {
        debouncedCallback(value, unit);
    };

    const incrementCallback = (value: string) => {
        if (!value) {
            debouncedCallback("", "");
            return;
        }
        const valueNum = parseInt(value);
        if (valueNum > max) {
            debouncedCallback(max.toString(), "");
        } else if (valueNum < min) {
            debouncedCallback(min.toString(), "");
        } else {
            debouncedCallback(valueNum.toString(), "");
        }
    };

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        if (e.currentTarget.value) {
            debouncedCallback(e.currentTarget.value, unit);
        }
    };

    return (
        <div className="slider-input-wrapper">
            {title && <OliverText text={t("generalComponents.sliderInput." + title)} size="xs" />}
            <div className="slider-input-row">
                <input type="range" value={rangeValue} min={min} max={max} onInput={handleChange} />
                <div className="custom-range-input">
                    <div className="track">
                        <div className="true-track">
                            <div className="before-thumb" style={{ width: `${percent}%` }}></div>
                            <div className="thumb" style={{ left: `${percent}%` }}></div>
                        </div>
                    </div>
                </div>
                {incrementMode ? (
                    <IncrementInput value={value} callback={incrementCallback} />
                ) : (
                    <UnitInput value={value || ""} unit={unit} callback={unitInputCallback} min={unitMin} max={unitMax} />
                )}
            </div>
        </div>
    );
};

export default SliderInput;
